<template>
  <div>
    <b-row class="align-items-center" align-v="center">
      <b-col cols="5" md="3" xl="2">
        <div class="logo-container">
          <img class="logo-tce pt-3" src="@/assets/logo-tce.png" />
        </div>
      </b-col>
      <b-col cols="0" md="5" lg="6" xl="4" class="pt-3 d-none d-md-block">
        <div class="info-sistema-wrapper">
          <div>
            <span class="title position-relative">Portal do TCE
              <b-badge v-if="!isProd" variant="success" class="align-top env-badge">{{ambiente.toUpperCase()}}</b-badge>
            </span>
            <span class="versao">(v.{{ versaoApp }})</span>
            <div class="subtitle">Protocolo Eletrônico</div>
          </div>
        </div>

      </b-col>
      <b-col v-if="showMessageNotificator" cols="3" md="2" lg="1" class="mt-4">
        <message-notificator ref="messageNotificator" />
      </b-col>
      <b-col v-if="!isLowerResolution" cols="0" xl="5" class="mt-4 d-xl-block">
        <ug-selector></ug-selector>
      </b-col>
      <b-col v-if="isLowerResolution" cols="4" md="2" xl="0" class="d-xl-none"></b-col>
      <b-col v-if="isLowerResolution" cols="12" xl="0" class="pb-1 pt-2 d-xl-none">
        <ug-selector></ug-selector>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { UtilsTS } from "@/utilsts"
import UgSelector from "./ug-selector.vue";
import MessageNotificator from "./message-notificator.vue";
import { store, isProd } from "@/store";
export default {
  name: "BaseHeaderComponent",
  mixins: [UtilsTS],
  components: {
    MessageNotificator,
    UgSelector,
  },
  data() {
    return {
      showMobileUGSelector: false,
      ambiente: store.ambiente,
      versaoApp: process.env.VUE_APP_VERSION,
      isProd: isProd()
    };
  },
  methods: {
    toggleUGSelection() {
      this.showMobileUGSelector = !this.showMobileUGSelector;
    },
  },
  computed: {
    showUGSelector() {
      return store.showUGSelector;
    },
    isLowerResolution() {
      return store.isLowerResolution
    },
    showMessageNotificator() {
      return store.primeiroAcesso == "N"
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Slabo+27px&display=swap");

.env-badge {
    font-size: 14px !important;
    margin-left: -0.5rem !important;
    margin-top: -0.5rem !important;
    position: absolute;
    top: 0.3rem;
    right: -2.5rem;
  }

#headerwrapper span.title {
  font-size: 1.5rem;
  font-family: "Slabo 27px", serif;
  font-weight: bold;
  color: var(--baseColor) !important;
  letter-spacing: 2px;
}

#headerwrapper span.versao {
  color: var(--baseColor) !important;
}

#headerwrapper div.subtitle {
  font-size: 1.2rem;
  font-family: "Slabo 27px", serif;
  font-weight: bold;
  color: var(--baseColor) !important;
}

#headerwrapper .row {
  margin: 0 !important;
}

.logo-container img {
  width: 100%;
  height: auto;
}

@media screen and (min-width: 630px) {
  .logo-container img {
    height: 80%;
    width: auto;
  }
}

@media screen and (min-width: 990px) {
  #headerwrapper span.title {
    font-size: 2.5rem;
  }
}

@media screen and (min-width: 1200px) {
  #headerwrapper span.title {
    font-size: 2.0rem;
  }
}

@media screen and (min-width: 1400px) {
  #headerwrapper span.title {
    font-size: 2.5rem;
  }
}
</style>
